module.exports = __webpack_public_path__ + "static/media/no-data.8b8279ee.svg";